import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_ready_for_dispatch_settings: { message: "idle" },
};

export const retrieve_ready_for_dispatch_settings_Slice = createSlice({
 name: "retrieve_ready_for_dispatch_settings",
 initialState,
 reducers: {
  success_retrieve_ready_for_dispatch_settings: (state, action) => {
   state.retrieve_ready_for_dispatch_settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_ready_for_dispatch_settings: (state, action) => {
   state.retrieve_ready_for_dispatch_settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_ready_for_dispatch_settings: (state) => {
   state.retrieve_ready_for_dispatch_settings = { status: app_consts.IDLE };
  },
  loading_retrieve_ready_for_dispatch_settings: (state) => {
   state.retrieve_ready_for_dispatch_settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_ready_for_dispatch_settings, fail_retrieve_ready_for_dispatch_settings, reset_retrieve_ready_for_dispatch_settings, loading_retrieve_ready_for_dispatch_settings } = retrieve_ready_for_dispatch_settings_Slice.actions;

export default retrieve_ready_for_dispatch_settings_Slice.reducer;